import { Directive, Input, TemplateRef } from "@angular/core";

@Directive({
  selector: "[appCarouselItem]",
  standalone: false,
})
export class CarouselItemDirective {
  /** 
   * Must be provided when the items in a carousel are not static. 
   * This is used to identify when carousel items change.
   * */
  @Input("appCarouselItem") key: string;

  constructor(private templateRef: TemplateRef<any>) {}
}
